import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    dialogPaper: {
      borderRadius: 16,
    },
    dialogHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px 24px',
      backgroundColor: '#f8fafc',
      borderBottom: '1px solid #eef0f3',
    },
    dialogHeaderIcon: {
      width: 44,
      height: 44,
      borderRadius: 12,
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(17, 98, 254, 0.1)',
      color: '#1162FE',
    },
    dialogTitleText: {
      fontSize: '1.15rem',
      fontWeight: 700,
      color: '#1f2937',
    },
    timezoneContainer: {
      marginTop: '1rem',
    },
    actionsContainer: {
      padding: '8px 20px 18px',
      gap: '12px',
    },
    dialogBtn: {
      textTransform: 'none',
      fontWeight: 600,
      borderRadius: 10,
      minWidth: 100,
    },
  };
});
